<template>
  <div class="card-item" :style="{ background: cardData.color }">
    <div class="card-top">
      {{ cardData.name }}
    </div>
    <div class="card-bottom">
      <div class="left-total">
        <div class="total-top">
          <span class="total-num">
            <count-to
              :startVal="0"
              :endVal="Number(cardData.totalNum ? cardData.totalNum : 0)"
              :duration="1000"
              separator=""
            ></count-to>
          </span>
          <span class="text-unit">{{ cardData.unit }}</span>
        </div>
        <div class="total-text">总计</div>
      </div>
      <div class="right-specail">
        <div class="specail-num">
          <span>
            <count-to
              :startVal="0"
              :endVal="Number(cardData.specailNum ? cardData.specailNum : 0)"
              :duration="1000"
              separator=""
            ></count-to>
          </span>
          <span class="specail-unit" v-if="cardData.specailUnit">{{ cardData.specailUnit }}</span>
        </div>
        <div class="specail-title">{{ cardData.specailTitle }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import countTo from 'vue-count-to'
export default {
  name: 'classCard',
  props: {
    cardData: {
      type: Object,
      default: null
    }
  },
  components: {
    countTo
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.card-item {
  height: 110px;
  // max-width: 566px;
  // min-width: 352px;
  padding: 16px 20px;
  color: #fff;
  .card-top {
    height: 16px;
    width: 100%;
    font-size: 16px;
    font-weight: 500;
  }
  .card-bottom {
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    font-size: 14px;
    .total-top {
      height: 28px;
    }
    .total-num {
      font-size: 28px;
      font-weight: 500;
    }
    .text-unit,
    .specail-unit,
    .specail-title {
      font-size: 12px;
      font-weight: 400;
    }
    .text-unit {
      margin-left: 8px;
    }
    .total-text {
      margin-top: 4px;
    }
    .specail-num {
      font-size: 16px;
      color: #8bfbff;
    }
    .specail-unit {
      margin-left: 2px;
    }
  }
}
</style>
